<template>
  <div class="soc-process-rail" role="list">
    <div
      v-for="(node, i) in nodes"
      :key="node.id || i"
      class="soc-process-rail__item"
    >
      <button
        type="button"
        class="soc-process-rail__node"
        :class="nodeClass(node)"
        @click="$emit('select', node)"
      >
        <span class="soc-process-rail__mark">{{ markFor(node, i) }}</span>
        <span class="soc-process-rail__title">{{ node.title }}</span>
        <span v-if="node.statusLabel" class="soc-process-rail__status">{{ node.statusLabel }}</span>
        <span v-else-if="node.stuck" class="soc-process-rail__now">{{ nowLabel }}</span>
      </button>
      <span
        v-if="i < nodes.length - 1"
        class="soc-process-rail__line"
        :class="{ 'is-done': node.done }"
        aria-hidden="true"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SocProcessRail',
  props: {
    nodes: { type: Array, default: function () { return [] } },
    nowLabel: { type: String, default: '当前' }
  },
  methods: {
    nodeClass: function (node) {
      return {
        'is-done': !!node.done,
        'is-stuck': !!node.stuck && !node.current,
        'is-current': !!node.current,
        'is-todo': !node.done && !node.stuck && !node.current
      }
    },
    markFor: function (node, i) {
      if (node.done) return '\u2713'
      if (node.current || node.stuck) return String(i + 1)
      return String(i + 1)
    }
  }
}
</script>

<style scoped>
.soc-process-rail {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 0;
}
.soc-process-rail__item {
  display: flex;
  align-items: center;
  flex: 1 1 140px;
  min-width: 132px;
}
.soc-process-rail__node {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  min-height: 72px;
  padding: 10px 12px;
  border: 1px solid var(--sap-color-border, #d9d9d9);
  border-radius: 8px;
  background: var(--sap-color-surface, #fff);
  color: var(--sap-color-text, #1a1a1a);
  text-align: left;
  cursor: pointer;
}
.soc-process-rail__node.is-done {
  border-color: #89b48a;
  background: #f3faf3;
  color: #3d5c3e;
}
.soc-process-rail__node.is-stuck {
  border-color: #d4a017;
  background: #fff8e6;
  box-shadow: 0 0 0 2px rgba(212, 160, 23, 0.25);
  font-weight: 600;
}
.soc-process-rail__node.is-current {
  border-color: #0a6ed1;
  background: #f5faff;
  box-shadow: inset 0 0 0 1px #0a6ed1;
  font-weight: 600;
}
.soc-process-rail__node.is-todo {
  color: var(--sap-color-text-secondary, #5b616b);
}
.soc-process-rail__mark {
  font-size: 12px;
  font-weight: 700;
  color: inherit;
}
.soc-process-rail__title {
  font-size: 13px;
  line-height: 1.35;
}
.soc-process-rail__status,
.soc-process-rail__now {
  font-size: 11px;
  color: var(--sap-color-text-secondary, #5b738b);
}
.soc-process-rail__now {
  color: #8a6a12;
}
.soc-process-rail__node.is-current .soc-process-rail__status {
  color: #0a6ed1;
}
.soc-process-rail__line {
  flex: 0 0 18px;
  height: 2px;
  margin: 0 4px;
  background: var(--sap-color-border, #d9d9d9);
}
.soc-process-rail__line.is-done {
  background: #89b48a;
}
</style>



// WEBPACK FOOTER //
// src/components/SocProcessRail.vue